
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class GstReportSummaryDialog extends Serenity.EntityDialog<GstReportSummaryRow, any> {
        protected getFormKey() { return GstReportSummaryForm.formKey; }
        protected getIdProperty() { return GstReportSummaryRow.idProperty; }
        protected getLocalTextPrefix() { return GstReportSummaryRow.localTextPrefix; }
        protected getService() { return GstReportSummaryService.baseUrl; }
        protected getDeletePermission() { return GstReportSummaryRow.deletePermission; }
        protected getInsertPermission() { return GstReportSummaryRow.insertPermission; }
        protected getUpdatePermission() { return GstReportSummaryRow.updatePermission; }

        protected form = new GstReportSummaryForm(this.idPrefix);

    }
}